import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLang, LANGS } from "@/i18n/LangContext";

const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher"
        className="flex items-center gap-1.5 text-xs tracking-[0.15em] uppercase text-[#A0A0A5] hover:text-[#D4AF37] transition-colors duration-300 outline-none p-2"
        aria-label="Idioma"
      >
        <Globe className="w-4 h-4" />
        {lang.toUpperCase()}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        data-testid="lang-menu"
        align="end"
        className="bg-[#141417] border border-[#F4F1EA]/10 text-[#F4F1EA] min-w-[150px]"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between gap-3 cursor-pointer text-sm hover:bg-[#D4AF37]/10 focus:bg-[#D4AF37]/10"
          >
            {l.label}
            {lang === l.code && <Check className="w-3.5 h-3.5 text-[#D4AF37]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
